import React from 'react';
import ReactDOM from 'react-dom';

import * as Sentry from '@sentry/react';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { history } from './utils/history';
import { Auth0Provider } from './react-auth0-spa';
import authConfig from './auth-config.json';
import { AuthorizedApolloProvider } from './authorized-apollo-client';
import './i18n';

// @ts-ignore
const config = authConfig[process.env.REACT_APP_MODE][process.env.REACT_APP_ENV];

const onRedirectCallback = async (url?: string) => {
	history.push(url ?? window.location.pathname);
};

if (document.location.host != 'localhost:3000') {
	Sentry.init({
		dsn: 'https://30ee1f252f60dcbdf5fb2c499c42e67a@o23207.ingest.us.sentry.io/4508086487154688',
		integrations: [
			Sentry.browserTracingIntegration(),
			Sentry.replayIntegration(),
		],

		// Set tracesSampleRate to 1.0 to capture 100%
		// of transactions for performance monitoring.
		// We recommend adjusting this value in production
		tracesSampleRate: 0.1,
		environment: process.env.REACT_APP_SENTRY_ENV || "dev",
		ignoreErrors: [
			"Response not successful: Received status code 401"
		],
		replaysSessionSampleRate: 0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
		replaysOnErrorSampleRate: 1.0,
	});
}

ReactDOM.render(
	<React.StrictMode>
		<Auth0Provider
			domain={config.domain}
			client_id={config.clientID}
			redirect_uri={config.redirectUri}
			audience={config.audience}
			onRedirectCallback={onRedirectCallback}
			cacheLocation="localstorage"
		>
			<AuthorizedApolloProvider>
				<App
					returnTo={config.returnTo}
					auth0Domain={config.domain}
				/>
			</AuthorizedApolloProvider>
		</Auth0Provider>
	</React.StrictMode>,
	document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
